/**
 * Liturgical colors that can be used as metadata for celebrations.
 */
export enum LiturgicalColors {
  RED = 'RED',
  ROSE = 'ROSE',
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
  WHITE = 'WHITE',
  GOLD = 'GOLD',
  BLACK = 'BLACK',
}
